import { render, staticRenderFns } from "./SearchProtocol.vue?vue&type=template&id=6983d6f3&"
import script from "./SearchProtocol.vue?vue&type=script&lang=js&"
export * from "./SearchProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports